import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router, RouterStateSnapshot } from '@angular/router';
import * as _ from 'lodash';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { CourseRequestMgmtService } from '../../counselor360/scheduling/course-request-mgmt/course-request-mgmt.service';
import { IdentifiedConflictsDTO } from '../../counselor360/scheduling/course-request-mgmt/models/identifiedConflicts.model';
import { SchoolCourseRequestModel } from '../../counselor360/scheduling/course-request-mgmt/models/school-course-request-model';
import { ErrorList } from '../../shared-components/controls/error-prompt/error-list.model';
import { GeneralConfirmationComponent } from '../../shared-components/controls/general-confirmation/general-confirmation.component';
import { MenuItem } from '../../shared-components/controls/menus/menu-item.model';
import { CourseDescriptionDialogComponent } from '../../shared-components/course-description-dialog/course-description-dialog.component';
import { HasErrors } from '../../shared-components/guards/check-for-errors/HasErrors';
import { PermissionEnum } from '../../shared-components/security/permissions.enums';
import { SecurityService } from '../../shared-components/security/security.service';
import { SharedService } from '../../shared-components/shared.service';
import { Enrollment } from '../../shared-components/student/enrollment.model';
import { StudentService } from '../../shared-components/student/student.service';
import { System } from '../../shared-components/System';
import { UserService } from '../../shared-components/user/user.service';
import { Year } from '../../shared-components/year/year.model';
import { YearService } from '../../shared-components/year/year.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { Student360Service } from '../student360.service';
import { CRWarningComponent } from './crwarning/crwarning.component';
import { CourseDescription, CourseRequestSchoolPolicyDTO, CRLookupDTO, CRRequirementCourses, GradeLevelRequirements, OverallRequirement, SchoolPoliciesCR360ParentStudentViewDTO, StudentCourseRequestDetailDTO, StudentCourseRequestDTO, StudentCourseRequestPreferredTeachers } from './student-course-request.model';
import { StudentCourseRequestService } from './student-course-request.service';


@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-student-course-request',
    templateUrl: './student-course-request.component.html',
    styleUrls: ['./student-course-request.component.css']
})
export class StudentCourseRequestComponent implements OnInit, AfterViewInit, HasErrors, OnDestroy {
    @ViewChildren('ddlCRCourse', { read: ElementRef }) ddlCRCourse: QueryList<ElementRef>;
    @ViewChild('studentHeader') studentHeaderRef: ElementRef;
    @ViewChild('footer', { static: true }) footerRef: ElementRef;
    studentHeaderHeight = 0;
    footerHeight = 0;
    public studentName: string;
    public userType = 0;
    public studentEnrollment: Enrollment;
    public selectedStudentSubscription: Subscription;
    public studentCourseRequests: StudentCourseRequestDetailDTO[];
    public initialStudentCourseRequests: StudentCourseRequestDetailDTO[];
    public gradeLevelRequirements: GradeLevelRequirements[] = [];
    public overAllRequirement: OverallRequirement;
    public termOptions: CRLookupDTO[] = [];
    public courseOptions: CRRequirementCourses[] = [];
    public periodsOptions: CRLookupDTO[] = [];
    public teacherOptions: CRLookupDTO[] = [];
    public preferredTeachers: StudentCourseRequestPreferredTeachers[] = [];
    public schoolPoliciesCR360ParentStudentView: SchoolPoliciesCR360ParentStudentViewDTO[] = [];
    public courseRequestSchoolPolicy: CourseRequestSchoolPolicyDTO;
    public periodPolicy: SchoolPoliciesCR360ParentStudentViewDTO;
    public termPolicy: SchoolPoliciesCR360ParentStudentViewDTO;
    public teacherPolicy: SchoolPoliciesCR360ParentStudentViewDTO;
    public gridHeight: number;
    public errorList: ErrorList[] = [];
    public errors: ErrorList[] = [];
    public tmpStudentCourseRequestId: number;
    crWarningDialogRef: MatDialogRef<CRWarningComponent>;
    public studentId: number;
    courseRequesrRequirementSource = new MatTableDataSource();
    ColumnsToDisplay: string[] = [];
    identifiedEnforcedConflicts: IdentifiedConflictsDTO[];
    identifiedPreferredConflicts: any[];
    courseDescriptions: { [courseID: number]: CourseDescription } = {};
    formIsDirty = false;
    subscriptions: Subscription[] = [];
    conflictMessages: string[] = [];
    IsFiltered: boolean;

    // Save data
    toAdd: StudentCourseRequestDTO[] = [];
    toDelete: StudentCourseRequestDTO[] = [];
    toUpdate: StudentCourseRequestDTO[] = [];
    toKeep: StudentCourseRequestDTO[] = [];

    // Counselor Properties
    counselor = false;
    toolsMenuItems = [
        'Schedule Student List',
        'Student Summary'
    ];
    disabledToolsMenuItems = [
        'Schedule Student List'
    ];
    counselorCanOverrideConflicts = false;

    constructor(
        private userService: UserService,
        private studentService: StudentService,
        private yearService: YearService,
        private studentCourseRequestService: StudentCourseRequestService,
        private parentPortalService: Student360Service,
        private router: Router,
        private dialog: MatDialog,
        private courseRequestMgmtService: CourseRequestMgmtService,
        private securityService: SecurityService,
        private loginService: LoginService,
        private classroom360Service: Classroom360Service,
        private sharedService: SharedService
    ) {
    }

    get courseRequestYear(): Year {
        return this.yearService.defaultCourseRequestYear;
    }

    ngOnInit() {
        this.userType = this.userService.userType;
        this.studentId = this.studentService.selectedStudent.Id;
        this.studentName = this.studentService.selectedStudent.LastName + ', ' + this.studentService.selectedStudent.FirstName + '(' + this.studentService.selectedStudent.StudentNumber + ')';

        // This page behaves differently for counselors (ONE-10172)
        if (this.userType == 1) {
            if (this.loginService.LoginSettings.V10) {
                this.counselor = this.securityService.IsAnyPermissionAssigned(PermissionEnum.AddCourseRequestRead);
                this.counselorCanOverrideConflicts = this.securityService.IsAnyPermissionAssigned(PermissionEnum.AllowConflictOverrides);
            } else {
                this.counselor = this.securityService.IsAnyPermissionCodeAssigned('SCH_CRE');
                this.counselorCanOverrideConflicts = this.securityService.IsAnyPermissionCodeAssigned('SCH_ACO');
            }
        }
        if (
            this.counselor
            && this.classroom360Service.staffAssignedPortals
            && (
                this.classroom360Service.staffAssignedPortals.find(portal =>
                    portal.PortalName == 'Schedule Student List'
                    && portal.ParentModule == 'Scheduling'
                ) != null
            )
        ) {
            System.removeFromList(this.disabledToolsMenuItems, 'Schedule Student List');
        }

        // Subscribing to application changes
        this.studentService.selectedStudentStream$.subscribe(() => {
            this.studentCourseRequests = undefined;
            this.loadStudentInfo();
        });

        if (this.counselor) {
            this.yearService.observableDefaultYearStream$.subscribe(() => {
                this.loadStudentInfo();
            });
        }
    }

    ngAfterViewInit() {
        if (this.studentHeaderRef != undefined) {
            this.studentHeaderHeight = this.studentHeaderRef.nativeElement.offsetHeight;
        }
        if (this.footerRef != undefined) {
            this.footerHeight = this.footerRef.nativeElement.offsetHeight;
        }
        this.onResize();
    }

    ngOnDestroy(): void {
    }

    loadStudentInfo() {
        const yearId = this.counselor ? this.yearService.defaultYear.Id : this.courseRequestYear.Id;
        this.studentService.getStudentEnrollment(this.studentService.selectedStudent.Id, yearId).subscribe(enrollment => {
            this.studentEnrollment = enrollment;
            this.studentService.studentEnrollment = enrollment;
            this.studentId = this.studentService.selectedStudent.Id;
            this.studentName = this.studentService.selectedStudent.LastName + ', ' + this.studentService.selectedStudent.FirstName + '(' + this.studentService.selectedStudent.StudentNumber + ')';
            if (this.studentEnrollment) {
                this.initialize();
            } else {
                this.dialog.open(GeneralConfirmationComponent, {
                    disableClose: true,
                    data: {
                        headerLabel: 'Student Not Enrolled',
                        confirmMessage: this.studentService.selectedStudent.FirstName + ' ' + this.studentService.selectedStudent.LastName + ' is not enrolled in during ' + this.yearService.defaultCourseRequestYear.AYIdentifier + '.',
                        informational: true
                    }
                });
            }
        });
    }

    hoverRow(row: StudentCourseRequestDTO) {
        this.studentCourseRequests.forEach(scr => {
            if (scr.DistrictRequirement_ID == row.DistrictRequirement_ID) {
                scr.isHover = true;
            }
        });
    }

    removehoverRow() {
        this.studentCourseRequests.forEach(scr => {
            scr.isHover = false;
        });
    }

    getRowSpan(scr: StudentCourseRequestDetailDTO) {
        if (scr.RowNumber == 1) {
            return 1;
        } else if (scr.RowNumber >= 2) {
            const count = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == scr.DistrictRequirement_ID);
            if (count.length > 2) {
                return count.length - 1;
            } else {
                return 1;
            }
        } else {
            return -1;
        }
    }

    initialize() {
        const serverCalls: Observable<any> = forkJoin([
            this.studentCourseRequestService.getCourseRequestStudent360SchoolPolicy(this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID),
            this.studentCourseRequestService.getCRCourses(this.studentEnrollment.StudentId, this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId),
            this.studentCourseRequestService.getCRTerms(this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId, this.studentEnrollment.StudentId),
            this.studentCourseRequestService.getCRPeriods(this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId, this.studentEnrollment.StudentId),
            this.studentCourseRequestService.getCRTeachers(this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId, this.studentEnrollment.StudentId),
            this.studentCourseRequestService.getCourseRequestSchoolPolicy(this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID),
            this.studentCourseRequestService.getStudentCourseRequestPreferredTeachers(this.studentEnrollment.StudentId, this.studentEnrollment.SiteYearId),
            this.studentCourseRequestService.massAddRequiredCourseRequests(this.studentEnrollment.SiteYearId, [this.studentEnrollment.StudentId])
        ]);
        serverCalls.subscribe(results => {
            this.schoolPoliciesCR360ParentStudentView = results[0];
            this.courseOptions = results[1];
            try {
                this.courseOptions.forEach(courseOption => {
                    let currentProperty = '';
                    for (let i = 0; i < courseOption.TextField.length; i++) {
                        if (courseOption.TextField[i] == '[') {
                            currentProperty = 'courseCredits';
                        } else if (courseOption.TextField[i] == ']') {
                            currentProperty = 'courseName';
                        } else if (courseOption.TextField[i] == '(') {
                            currentProperty = 'courseNumber';
                        } else if (courseOption.TextField[i] == ')') {
                            currentProperty = '';
                        } else if (currentProperty) {
                            if (!courseOption[currentProperty]) {
                                courseOption[currentProperty] = '';
                            }
                            courseOption[currentProperty] += courseOption.TextField[i];
                        }
                    }
                    courseOption.courseCredits = courseOption.courseCredits.trim();
                    courseOption.courseName = courseOption.courseName.trim();
                    courseOption.courseNumber = courseOption.courseNumber.trim();

                    const courseId = courseOption.CourseId;
                    if (!this.courseDescriptions[courseId]) {
                        this.courseDescriptions[courseId] = new CourseDescription();
                        this.courseDescriptions[courseId].CourseCurriculum = courseOption.CourseCurriculum;
                        this.courseDescriptions[courseId].CourseDescription = courseOption.CourseDescription;
                        this.courseDescriptions[courseId].CourseName = courseOption.CourseName;
                        this.courseDescriptions[courseId].CourseNumber = courseOption.TextField;
                        this.courseDescriptions[courseId].SubjectIdentifier = courseOption.SubjectIdentifier;
                    }

                });
                this.courseOptions.sort((a, b) => {
                    const nameComparison = a.courseName.toLowerCase().localeCompare(b.courseName.toLowerCase());
                    if (nameComparison != 0) {
                        return nameComparison;
                    } else {
                        return a.courseNumber.toLowerCase().localeCompare(b.courseNumber.toLowerCase());
                    }
                });
            } catch (e) {
                console.error('Cannot order course options: ' + e.toString());
            }
            this.termOptions = results[2];
            this.periodsOptions = results[3];
            this.teacherOptions = results[4];
            this.courseRequestSchoolPolicy = results[5];
            this.preferredTeachers = results[6];


            this.periodPolicy = this.schoolPoliciesCR360ParentStudentView.find(x => x.ColumnToCheck.toLowerCase() == 'period');
            this.teacherPolicy = this.schoolPoliciesCR360ParentStudentView.find(x => x.ColumnToCheck.toLowerCase() == 'teacher');
            this.termPolicy = this.schoolPoliciesCR360ParentStudentView.find(x => x.ColumnToCheck.toLowerCase() == 'term');

            this.ColumnsToDisplay = ['RequirementName', 'ReqMinCredits', 'ReqMaxCredits', 'RequestedCredits', 'ReqMinCourses', 'ReqMaxCourses', 'RequestedCourses', 'CRType', 'Credits_Course'];
            if (this.periodPolicy != undefined && this.periodPolicy.CanDisplay == true) {
                this.ColumnsToDisplay.push('PreferredPeriod');
            }
            if (this.termPolicy != undefined && this.termPolicy.CanDisplay == true) {
                this.ColumnsToDisplay.push('PreferredTerm');
            }
            if (this.teacherPolicy != undefined && this.teacherPolicy.CanDisplay == true) {
                this.ColumnsToDisplay.push('PreferredTeacher');
            }
            this.ColumnsToDisplay.push('Conflicts');
            this.ColumnsToDisplay.push('actions');
            this.getStudentCourseRequestInformation();
        });
    }

    getStudentCourseRequestInformation() {
        const crserverCalls: Observable<any> = forkJoin([
            this.studentCourseRequestService.getCourseRequestOverAllRequirements(this.studentEnrollment.StudentId, this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId),
            this.studentCourseRequestService.getStudentCourseRequest(this.studentEnrollment.StudentId, this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId)
        ]);
        crserverCalls.subscribe(results => {
            this.tmpStudentCourseRequestId = -1;
            this.overAllRequirement = results[0];
            this.gradeLevelRequirements = results[1];

            this.gradeLevelRequirements.forEach(req => {
                req.StudentCourseRequest.forEach(scr => {
                    scr.isHiddenRow = false;
                });
                const tmpScr = new StudentCourseRequestDTO();
                tmpScr.DistrictRequirement_ID = req.DistrictRequirement_ID;
                tmpScr.StudentCourseRequest_ID = 0;
                tmpScr.DistrictCourse_ID = 0;
                tmpScr.CRType = '';
                tmpScr.ParentCR_ID = 0;
                tmpScr.PreferredTeacher = 0;
                tmpScr.PreferredTeacherNameSetByCounselor = '';
                tmpScr.PreferredTerm = '';
                tmpScr.PreferredPeriod = '';
                tmpScr.Conflicts = 0;
                tmpScr.isHiddenRow = true;
                if (req.StudentCourseRequest.length == 0) {
                    req.StudentCourseRequest.push(tmpScr);
                    req.StudentCourseRequest.push(tmpScr);
                }
                if (req.StudentCourseRequest.length == 1) {
                    req.StudentCourseRequest.push(tmpScr);
                }
            });
            this.studentCourseRequests = this.gradeLevelRequirements.reduce((current, next) => {
                let rowNumber: number;
                rowNumber = 1;
                next.StudentCourseRequest.forEach(b => {
                    if (b.PreferredTeacher != 0) {
                        if (this.preferredTeachers.find(x => x.PreferredTeacherStaff_ID == b.PreferredTeacher)) {
                            b.PreferredTeacherNameSetByCounselor = this.preferredTeachers.find(x => x.PreferredTeacherStaff_ID == b.PreferredTeacher).PreferredTeacherName;
                        } else {
                            b.PreferredTeacherNameSetByCounselor = '';
                        }
                    } else {
                        b.PreferredTeacherNameSetByCounselor = '';
                    }
                    current.push({
                        RowNumber: rowNumber,
                        DistrictRequirement_ID: next.DistrictRequirement_ID,
                        SchoolRequirement_ID: next.SchoolRequirement_ID,
                        GradeLevel_ID: next.GradeLevel_ID,
                        RequirementName: next.RequirementName,
                        RequirementInstructions: next.RequirementInstructions,
                        RequirementType: next.RequirementType,
                        ReqMinCredits: next.ReqMinCredits,
                        ReqMaxCredits: next.ReqMaxCredits,
                        ReqMaxCourses: next.ReqMaxCourses,
                        ReqMinCourses: next.ReqMinCourses,
                        DefaultNumberOfCourseRequests: next.DefaultNumberOfCourseRequests,
                        AllowGlobalAlternates: next.AllowGlobalAlternates,
                        AltMinCredits: next.AltMinCredits,
                        AltMaxCredits: next.AltMaxCredits,
                        AltMinCourses: next.AltMinCourses,
                        AltMaxCourses: next.AltMaxCourses,
                        AllowIndividualAlternates: next.AllowIndividualAlternates,
                        NumberOfIndividualAlternates: next.NumberOfIndividualAlternates,
                        RequestedCredits: next.RequestedCredits,
                        StudentCourseRequest_ID: b.StudentCourseRequest_ID,
                        DistrictCourse_ID: b.DistrictCourse_ID,
                        CRType: b.CRType,
                        Status: b.Status,
                        ParentCR_ID: b.ParentCR_ID,
                        PreferredTeacher: b.PreferredTeacher,
                        PreferredTeacherNameSetByCounselor: b.PreferredTeacherNameSetByCounselor,
                        PreferredTerm: b.PreferredTerm,
                        PreferredPeriod: b.PreferredPeriod,
                        Conflicts: b.Conflicts,
                        isHiddenRow: b.isHiddenRow,
                        isHover: false,
                        HighlightMinCredit: false,
                        HighlightMaxCredit: false,
                        HighlightMinCourses: false,
                        HighlightMaxCourses: false
                    });
                    rowNumber = rowNumber + 1;
                });
                return current;
            }, []);
            this.studentCourseRequests = _.sortBy(this.studentCourseRequests, ['DistrictRequirement_ID', 'RowNumber']);
            this.studentCourseRequests.forEach(req => {
                if (req.StudentCourseRequest_ID == null || req.StudentCourseRequest_ID == undefined || req.StudentCourseRequest_ID < 1) {
                    req.StudentCourseRequest_ID = this.tmpStudentCourseRequestId;
                    this.tmpStudentCourseRequestId = this.tmpStudentCourseRequestId - 1;
                }
                if (req.ParentCR_ID == null || req.ParentCR_ID == undefined || req.ParentCR_ID < 1) {
                    req.ParentCR_ID = 0;
                }
                if (req.DistrictCourse_ID == undefined) {
                    req.DistrictCourse_ID = 0;
                }
            });
            this.reinitializeRowNumber();
            this.setCreditIndicators();
            this.initialStudentCourseRequests = _.cloneDeep(this.studentCourseRequests);
        });
    }

    courseChange(crRow: StudentCourseRequestDetailDTO) {
        crRow.PreferredPeriod = '';
        crRow.PreferredTeacher = 0;
        crRow.PreferredTerm = '';
        this.setCreditIndicators();
    }

    setCreditIndicators() {
        let overallRecuirementCredits: number;
        overallRecuirementCredits = 0.00;

        let overallRequirementCourses: number;
        overallRequirementCourses = 0;

        this.gradeLevelRequirements.forEach(ci => {
            let totalRecuirementCredits: number;
            totalRecuirementCredits = 0.00;
            let totalRequirementCourses: number;
            totalRequirementCourses = 0;
            const studentCRs = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == ci.DistrictRequirement_ID);
            studentCRs.forEach(scr => {
                if (scr.DistrictCourse_ID > 0 && scr.CRType == 'Primary') {
                    overallRequirementCourses += 1;
                    totalRequirementCourses += 1;
                    const tempCourse = this.courseOptions.find(x => x.CourseId == scr.DistrictCourse_ID);
                    if (tempCourse != null && tempCourse != undefined) {
                        if (this.loginService.LoginSettings.V10 == true) {
                            totalRecuirementCredits += tempCourse.Credits;
                        } else {
                            let courseCredit: number;
                            courseCredit = 0.0;
                            if (tempCourse.SubjectTermType == 'Y' && tempCourse.CreditDeliveryTermType == 'Y' && scr.PreferredTerm.startsWith('S')) {
                                courseCredit = tempCourse.Credits / tempCourse.SemestersPerYear;
                            }
                            else if (tempCourse.SubjectTermType == 'Y' && tempCourse.CreditDeliveryTermType == 'S' && scr.PreferredTerm.trim() == '') {
                                courseCredit = tempCourse.Credits * tempCourse.SemestersPerYear;
                            }
                            else if (tempCourse.SubjectTermType == 'Y' && tempCourse.CreditDeliveryTermType == 'T' && scr.PreferredTerm.trim() == '') {
                                courseCredit = tempCourse.Credits * tempCourse.SemestersPerYear * tempCourse.TermsPerSemesters;
                            }
                            else if (tempCourse.SubjectTermType == 'Y' && tempCourse.CreditDeliveryTermType == 'T' && scr.PreferredTerm.startsWith('S')) {
                                courseCredit = tempCourse.Credits * tempCourse.TermsPerSemesters;
                            }
                            else if (tempCourse.SubjectTermType == 'S' && tempCourse.CreditDeliveryTermType == 'Y') {
                                courseCredit = tempCourse.Credits / tempCourse.SemestersPerYear;
                            }
                            else if (tempCourse.SubjectTermType == 'S' && tempCourse.CreditDeliveryTermType == 'T') {
                                courseCredit = tempCourse.Credits * tempCourse.TermsPerSemesters;
                            }
                            else {
                                courseCredit = tempCourse.Credits;
                            }
                            totalRecuirementCredits += courseCredit;
                        }
                    }
                }
            });
            ci.RequestedCredits = totalRecuirementCredits;
            ci.RequestedCourses = totalRequirementCourses;
            if (totalRecuirementCredits < ci.ReqMinCredits) {
                ci.HighlightMinCredit = true;
            } else {
                ci.HighlightMinCredit = false;
            }
            if (totalRecuirementCredits > ci.ReqMaxCredits && ci.ReqMaxCredits > 0) {
                ci.HighlightMaxCredit = true;
            } else {
                ci.HighlightMaxCredit = false;
            }
            if (ci.ReqMinCourses != null && totalRequirementCourses < ci.ReqMinCourses) {
                ci.HighlightMinCourses = true;
            } else {
                ci.HighlightMinCourses = false;
            }
            if (ci.ReqMaxCourses != null && totalRequirementCourses > ci.ReqMaxCourses) {
                ci.HighlightMaxCourses = true;
            } else {
                ci.HighlightMaxCourses = false;
            }
            overallRecuirementCredits += totalRecuirementCredits;
            ci.RequestedCourses = totalRequirementCourses;

        });
        this.studentCourseRequests.forEach(scr => {
            const crRow = this.gradeLevelRequirements.find(x => x.DistrictRequirement_ID == scr.DistrictRequirement_ID);
            if (crRow != undefined) {
                scr.RequestedCredits = crRow.RequestedCredits;
                scr.HighlightMinCredit = crRow.HighlightMinCredit;
                scr.HighlightMaxCredit = crRow.HighlightMaxCredit;
                scr.HighlightMinCourses = crRow.HighlightMinCourses;
                scr.HighlightMaxCourses = crRow.HighlightMaxCourses;
                scr.RequestedCourses = crRow.RequestedCourses;
            }
        });
        this.overAllRequirement.RequestedCredits = overallRecuirementCredits;
        if (overallRecuirementCredits < this.overAllRequirement.ReqMinCredits) {
            this.overAllRequirement.HighlightOverallMinCredit = true;
        } else {
            this.overAllRequirement.HighlightOverallMinCredit = false;
        }
        if (overallRecuirementCredits > 0 && overallRecuirementCredits > this.overAllRequirement.ReqMaxCredits) {
            this.overAllRequirement.HighlightOverallMaxCredit = true;
        } else {
            this.overAllRequirement.HighlightOverallMaxCredit = false;
        }

        this.overAllRequirement.RequestedCourses = overallRequirementCourses;
        if (this.overAllRequirement.ReqMinCourses != null && overallRequirementCourses < this.overAllRequirement.ReqMinCourses) {
            this.overAllRequirement.HighlightOverallMinCourses = true;
        } else {
            this.overAllRequirement.HighlightOverallMinCourses = false;
        }
        if (this.overAllRequirement.ReqMaxCourses != null && overallRequirementCourses > this.overAllRequirement.ReqMaxCourses) {
            this.overAllRequirement.HighlightOverallMaxCourses = true;
        } else {
            this.overAllRequirement.HighlightOverallMaxCourses = false;
        }

    }

    addRow(crReq: StudentCourseRequestDetailDTO, index: number) {
        if (crReq.isHiddenRow == true) {
            // First Hidden Row
            crReq.StudentCourseRequest_ID = this.tmpStudentCourseRequestId;
            crReq.DistrictCourse_ID = -1;
            crReq.CRType = 'Primary';
            crReq.ParentCR_ID = 0;
            crReq.PreferredTeacher = -1;
            crReq.PreferredTerm = '';
            crReq.PreferredPeriod = '';
            crReq.isHiddenRow = false;
            this.tmpStudentCourseRequestId = this.tmpStudentCourseRequestId - 1;
        }
        else {
            const newRow: StudentCourseRequestDetailDTO = Object.assign({}, crReq);
            newRow.StudentCourseRequest_ID = this.tmpStudentCourseRequestId;
            newRow.DistrictCourse_ID = -1;
            newRow.CRType = 'Primary';
            newRow.ParentCR_ID = 0;
            newRow.PreferredTeacher = -1;
            newRow.PreferredTerm = '';
            newRow.PreferredPeriod = '';
            newRow.Status = 'P';

            crReq.isHiddenRow = false;
            const hiddenRow = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == crReq.DistrictRequirement_ID && x.isHiddenRow == true);
            if (hiddenRow.length == 1) {
                // If one hidden Row exists on 2nd index then remove it and recreate a new Valid Row
                this.studentCourseRequests.splice(index + 1, 1);
                this.studentCourseRequests.push(newRow);
                this.tmpStudentCourseRequestId = this.tmpStudentCourseRequestId - 1;
            } else {
                this.studentCourseRequests.push(newRow);
                this.tmpStudentCourseRequestId = this.tmpStudentCourseRequestId - 1;
            }
        }
        this.reinitializeRowNumber();
    }

    addCourseSpecificAlternateRequest(crReq: StudentCourseRequestDetailDTO, index: number) {
        const newRow: StudentCourseRequestDetailDTO = Object.assign({}, crReq);
        const courseSpecificAlternateRequestCount = this.studentCourseRequests.filter(y => y.ParentCR_ID == crReq.StudentCourseRequest_ID && y.DistrictRequirement_ID == crReq.DistrictRequirement_ID).length;
        newRow.StudentCourseRequest_ID = this.tmpStudentCourseRequestId;
        newRow.DistrictCourse_ID = -1;
        newRow.CRType = 'Alternate';
        newRow.ParentCR_ID = crReq.StudentCourseRequest_ID;
        newRow.PreferredTeacher = -1;
        newRow.PreferredTerm = '';
        newRow.PreferredPeriod = '';
        crReq.isHiddenRow = false;
        const hiddenRow = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == crReq.DistrictRequirement_ID && x.isHiddenRow == true);
        if (hiddenRow.length == 1) {
            // If one hidden Row exists on 2nd index then remove it and recreate a new Valid Row
            this.studentCourseRequests.splice(index + 1, 1);
            this.studentCourseRequests.push(newRow);
        } else {
            this.studentCourseRequests.splice(index + courseSpecificAlternateRequestCount + 1, 0, newRow);
        }

        this.tmpStudentCourseRequestId = this.tmpStudentCourseRequestId - 1;
        this.reinitializeRowNumber();
    }
    setImagePath() {
        this.gradeLevelRequirements.forEach(element => {
            const parentCRs = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == element.DistrictRequirement_ID && x.ParentCR_ID == 0);
            parentCRs.forEach(pcr => {
                const courseSpecificAlternateRequest = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == element.DistrictRequirement_ID && x.ParentCR_ID == pcr.StudentCourseRequest_ID);
                let counter: number;
                counter = 1;
                courseSpecificAlternateRequest.forEach(obj => {
                    obj.imageUrl = '';
                    if (counter == 1) {
                        if (courseSpecificAlternateRequest.length == 1) {
                            obj.imageUrl = './assets/images/acr-indicator-1.png';
                        } else {
                            obj.imageUrl = './assets/images/acr-indicator-1_1.png';
                        }
                    }
                    if (counter > 1 && counter == courseSpecificAlternateRequest.length) {
                        obj.imageUrl = './assets/images/acr-indicator-3.png';
                    }
                    if (counter > 1 && counter != courseSpecificAlternateRequest.length) {
                        obj.imageUrl = './assets/images/acr-indicator-2.png';
                    }
                    counter = counter + 1;
                });
            });

        });
    }
    reinitializeRowNumber() {
        this.gradeLevelRequirements.forEach(req => {
            let counter: number;
            counter = 1;
            this.studentCourseRequests.forEach(scr => {
                if (req.DistrictRequirement_ID == scr.DistrictRequirement_ID) {
                    scr.RowNumber = counter;
                    counter = counter + 1;
                }

            });
        });
        this.studentCourseRequests = _.sortBy(this.studentCourseRequests, ['DistrictRequirement_ID', 'RowNumber']);
        this.setImagePath();
        this.courseRequesrRequirementSource.data = this.studentCourseRequests;
    }

    getChanges(initalCourseRequests: StudentCourseRequestDetailDTO[], courseRequestsToUpdate: StudentCourseRequestDetailDTO[]) {

        const initCr: StudentCourseRequestDTO[] = [];
        this.toAdd = [];
        this.toDelete = [];
        this.toKeep = [];
        this.toUpdate = [];

        initalCourseRequests.forEach(scr => {
            if (scr.DistrictCourse_ID > 0) {
                const tmpSCR = new StudentCourseRequestDTO();
                tmpSCR.DistrictRequirement_ID = scr.DistrictRequirement_ID;
                tmpSCR.StudentCourseRequest_ID = scr.StudentCourseRequest_ID;
                tmpSCR.DistrictCourse_ID = scr.DistrictCourse_ID;
                tmpSCR.CRType = scr.CRType;
                tmpSCR.ParentCR_ID = scr.ParentCR_ID;
                tmpSCR.PreferredTeacher = scr.PreferredTeacher;
                tmpSCR.PreferredTerm = scr.PreferredTerm;
                tmpSCR.PreferredPeriod = scr.PreferredPeriod;
                initCr.push(tmpSCR);
            }
        });

        const updateCr: StudentCourseRequestDTO[] = [];
        courseRequestsToUpdate.forEach(scr => {
            if (scr.DistrictCourse_ID > 0) {
                const tmpSCR = new StudentCourseRequestDTO();
                tmpSCR.DistrictRequirement_ID = scr.DistrictRequirement_ID;
                tmpSCR.StudentCourseRequest_ID = scr.StudentCourseRequest_ID;
                tmpSCR.DistrictCourse_ID = scr.DistrictCourse_ID;
                tmpSCR.CRType = scr.CRType;
                tmpSCR.ParentCR_ID = scr.ParentCR_ID;
                tmpSCR.PreferredTeacher = scr.PreferredTeacher;
                tmpSCR.PreferredTerm = scr.PreferredTerm;
                tmpSCR.PreferredPeriod = scr.PreferredPeriod;
                updateCr.push(tmpSCR);
            }
        });

        initCr.forEach(element => {
            const tmpRecord: StudentCourseRequestDTO = updateCr.find(x => x.StudentCourseRequest_ID == element.StudentCourseRequest_ID);
            if (tmpRecord) {
                if (_.isEqual(tmpRecord, element)) {
                    this.toKeep.push(element);
                } else {
                    if (element.DistrictCourse_ID != tmpRecord.DistrictCourse_ID) {
                        // if the course was changed, delete the original, add the new
                        if (tmpRecord.DistrictRequirement_ID != -1) {
                            this.toAdd.push(tmpRecord);
                            this.toDelete.push(element);
                        }
                    } else {
                        // if the course wasn't changed, then update the parameters
                        this.toUpdate.push(tmpRecord);
                    }
                }
            } else {
                // record removed, so delete it.
                this.toDelete.push(element);
            }
        });

        // check for new records
        updateCr.forEach(element => {
            const tmpRecord: StudentCourseRequestDTO = initCr.find(x => x.StudentCourseRequest_ID == element.StudentCourseRequest_ID);
            if (!tmpRecord) {
                this.toAdd.push(element);
            }
        });
        /*
        console.log('Keep', this.toKeep);
        console.log('To Delete', this.toDelete);
        console.log('To Update', this.toUpdate);
        console.log('To Add', this.toAdd);
        */
    }

    save() {
        this.formIsDirty = false;
        this.validateAndSave();
    }

    validateAndSave() {

        this.getChanges(this.initialStudentCourseRequests, this.studentCourseRequests);


        this.errorList = [];
        this.errors = [];
        let overallRecuirementCredits: number;
        overallRecuirementCredits = 0.00;

        if (this.studentCourseRequests.filter(x => x.DistrictCourse_ID > 0).length < 1) {
            const error: ErrorList = {
                fieldName: '',
                errorMsg: 'at least one course must be selected.',
                fieldRef: null
            };
            this.errors.push(error);
            return false;
        }

        this.gradeLevelRequirements.forEach(requirement => {
            let totalRecuirementCredits: number;
            totalRecuirementCredits = 0.00;
            const courseRequestInfo = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == requirement.DistrictRequirement_ID);
            const requirementCourses: CRRequirementCourses[] = [];
            courseRequestInfo.forEach(cri => {
                if (cri.DistrictCourse_ID > 0) {
                    const tempCourse = this.courseOptions.find(x => x.CourseId == cri.DistrictCourse_ID);
                    if (tempCourse != undefined) {
                        let courseName: string;
                        if (tempCourse.TextField.split(']').length == 2) {
                            courseName = tempCourse.TextField.split(']')[1].trim();
                        } else {
                            courseName = tempCourse.TextField;
                        }

                        if (tempCourse != undefined) {
                            if (cri.CRType == 'Primary') {
                                requirementCourses.push(tempCourse);
                            }
                            if (this.loginService.LoginSettings.V10 == true) {
                                totalRecuirementCredits += tempCourse.Credits;
                            } else {
                                let courseCredit: number;
                                courseCredit = 0.0;
                                if (cri.CRType == 'Primary') {
                                    if (tempCourse.SubjectTermType == 'Y' && tempCourse.CreditDeliveryTermType == 'Y' && cri.PreferredTerm.startsWith('S')) {
                                        courseCredit = tempCourse.Credits / tempCourse.SemestersPerYear;
                                    }
                                    else if (tempCourse.SubjectTermType == 'Y' && tempCourse.CreditDeliveryTermType == 'S' && cri.PreferredTerm.trim() == '') {
                                        courseCredit = tempCourse.Credits * tempCourse.SemestersPerYear;
                                    }
                                    else if (tempCourse.SubjectTermType == 'Y' && tempCourse.CreditDeliveryTermType == 'T' && cri.PreferredTerm.trim() == '') {
                                        courseCredit = tempCourse.Credits * tempCourse.SemestersPerYear * tempCourse.TermsPerSemesters;
                                    }
                                    else if (tempCourse.SubjectTermType == 'Y' && tempCourse.CreditDeliveryTermType == 'T' && cri.PreferredTerm.startsWith('S')) {
                                        courseCredit = tempCourse.Credits * tempCourse.TermsPerSemesters;
                                    }
                                    else if (tempCourse.SubjectTermType == 'S' && tempCourse.CreditDeliveryTermType == 'Y') {
                                        courseCredit = tempCourse.Credits / tempCourse.SemestersPerYear;
                                    }
                                    else if (tempCourse.SubjectTermType == 'S' && tempCourse.CreditDeliveryTermType == 'T') {
                                        courseCredit = tempCourse.Credits * tempCourse.TermsPerSemesters;
                                    }
                                    else {
                                        courseCredit = tempCourse.Credits;
                                    }
                                }
                                totalRecuirementCredits += courseCredit;
                            }
                        }
                    }
                }
            });

            // uncomment to test
            // this.courseRequestSchoolPolicy.CR360PreventParentStudentSubmittingCourseRequests = true;
            // this.courseRequestSchoolPolicy.CR360EnforceRule = 'warning';
            if (this.courseRequestSchoolPolicy.CR360PreventParentStudentSubmittingCourseRequests == true
                && totalRecuirementCredits < requirement.ReqMinCredits) {
                const error: ErrorList = {
                    fieldName: requirement.RequirementName,
                    errorMsg: this.studentName + ' has fewer than the minimum credits requested for requirement ' + requirement.RequirementName + '.',
                    fieldRef: null
                };
                this.errorList.push(error);
            }
            if (this.courseRequestSchoolPolicy.CR360PreventParentStudentSubmittingCourseRequests == true
                && totalRecuirementCredits > requirement.ReqMaxCredits && requirement.ReqMaxCredits > 0) {
                const error: ErrorList = {
                    fieldName: requirement.RequirementName,
                    errorMsg: this.studentName + ' has more than the maximum credits requested for requirement ' + requirement.RequirementName + '.',
                    fieldRef: null
                };
                this.errorList.push(error);
            }
            overallRecuirementCredits += totalRecuirementCredits;

        });

        if (this.courseRequestSchoolPolicy.CR360PreventParentStudentSubmittingCourseRequests == true
            && overallRecuirementCredits < this.overAllRequirement.ReqMinCredits) {
            const error: ErrorList = {
                fieldName: '',
                errorMsg: this.studentName + ' has fewer than the minimum overall credits requested.',
                fieldRef: null
            };
            this.errorList.push(error);
        }
        if (this.courseRequestSchoolPolicy.CR360PreventParentStudentSubmittingCourseRequests == true
            && this.overAllRequirement.ReqMaxCredits > 0 && overallRecuirementCredits > this.overAllRequirement.ReqMaxCredits) {
            const error: ErrorList = {
                fieldName: '',
                errorMsg: this.studentName + ' has more than the maximum overall credits requested.',
                fieldRef: null
            };
            this.errorList.push(error);
        }

        let enforceRule = 'error';
        if (this.counselor && this.counselorCanOverrideConflicts) {
            enforceRule = 'warning';
        } else {
            enforceRule = this.courseRequestSchoolPolicy.CR360EnforceRule;
        }

        if (this.errorList.length > 0) {
            this.crWarningDialogRef = this.dialog.open(CRWarningComponent, {
                disableClose: true,
                minWidth: '450px',
                maxWidth: '500px',
                data: { errorList: this.errorList, enforceRule: enforceRule }
            });
            this.crWarningDialogRef.afterClosed().subscribe((result: any) => {
                if (result == 'Save Anyway was clicked') {
                    this.saveData();
                }
            });
        } else {
            this.saveData();
        }
    }

    saveData() {
        const studentCourseRequest: StudentCourseRequestDTO[] = [];
        this.studentCourseRequests.forEach(scr => {
            if (scr.DistrictCourse_ID > 0 && scr.DistrictRequirement_ID != -1) {
                const tmpSCR = new StudentCourseRequestDTO();
                tmpSCR.DistrictRequirement_ID = scr.DistrictRequirement_ID;
                tmpSCR.StudentCourseRequest_ID = scr.StudentCourseRequest_ID;
                tmpSCR.DistrictCourse_ID = scr.DistrictCourse_ID;
                tmpSCR.CRType = scr.CRType;
                tmpSCR.ParentCR_ID = scr.ParentCR_ID;
                tmpSCR.PreferredTeacher = scr.PreferredTeacher;
                tmpSCR.PreferredTerm = scr.PreferredTerm;
                tmpSCR.PreferredPeriod = scr.PreferredPeriod;
                studentCourseRequest.push(tmpSCR);
            }
        });

        const courseRequestData = {
            students: [this.studentService.selectedStudent.Id].map(x => ({ student_id: x })),
            coursesToAdd: {
                course:
                    this.toAdd.filter(y => y.DistrictCourse_ID > 0 && y.DistrictRequirement_ID != -1).map(x => ({
                        DistrictCourse_ID: x.DistrictCourse_ID,
                        RequirementIds: x.DistrictRequirement_ID,
                        CRType: x.CRType,
                        PreferredTeacher: x.PreferredTeacher == 0 ? null : x.PreferredTeacher,
                        PreferredTerm: x.PreferredTerm,
                        PreferredPeriod: x.PreferredPeriod,
                        RequirementType: 1,
                        ParentCR_ID: x.ParentCR_ID
                    })
                    )
            },
        };


        // deletes / updates / adds
        const courseRequestsToDelete: SchoolCourseRequestModel[] = [];
        this.toDelete.forEach(element => {
            if (element.DistrictCourse_ID > 0 && element.DistrictRequirement_ID != -1) {
                const tempCr: SchoolCourseRequestModel = new SchoolCourseRequestModel();
                tempCr.StudentCourseRequest_ID = element.StudentCourseRequest_ID;
                courseRequestsToDelete.push(tempCr);
            }
        });

        if (courseRequestsToDelete.length > 0) {
            this.courseRequestMgmtService.deleteSchoolCourseRequests(courseRequestsToDelete).subscribe(result => {
                if (this.toUpdate.length > 0) {
                    this.studentCourseRequestService.saveCourseRequestData(this.studentEnrollment.StudentId, this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId, this.toUpdate).subscribe(updateResult => {
                        this.addNewRecords(courseRequestData);
                    });
                } else {
                    this.addNewRecords(courseRequestData);
                }
            });
        } else {
            if (this.toUpdate.length > 0) {
                this.studentCourseRequestService.saveCourseRequestData(this.studentEnrollment.StudentId, this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId, this.toUpdate).subscribe(updateResult => {
                    this.addNewRecords(courseRequestData);
                });
            } else {
                this.addNewRecords(courseRequestData);
            }
        }

        // this.studentCourseRequestService.saveCourseRequestData(this.studentEnrollment.StudentId, this.studentEnrollment.SchoolId, this.studentEnrollment.AcademicYearID, this.studentEnrollment.GradeLevelId, studentCourseRequest).subscribe(result => {
        //    if (result == true) {
        //        this.getStudentCourseRequestInformation();
        //    }
        // });
    }

    addNewRecords(courseRequestData) {
        this.courseRequestMgmtService.AddRemoveCourseRequestInMass(courseRequestData, this.counselor ? false : true, this.studentEnrollment.SiteYearId).subscribe(addResults => {
            this.identifiedEnforcedConflicts = [];
            this.identifiedPreferredConflicts = [];
            let enforceRule = '';
            let idConflicts: IdentifiedConflictsDTO[];
            idConflicts = addResults.identifiedConflicts;
            idConflicts.forEach(element => {
                if (element.RelationshipEnforcement == 3) {
                    this.identifiedEnforcedConflicts.push(element);
                }
                if (element.RelationshipEnforcement == 2) {
                    this.identifiedPreferredConflicts.push(element);
                }
            });
            let errorTitle = '';
            let hasEnforcedConflicts = false;
            let hasPreferredConflicts = false;
            if (this.identifiedEnforcedConflicts.length > 0) {
                hasEnforcedConflicts = true;
            }
            if (this.identifiedPreferredConflicts.length > 0) {
                hasPreferredConflicts = true;
            }
            if (hasEnforcedConflicts && hasPreferredConflicts) {
                errorTitle = 'Some requests could not be met due to the following errors:';
            }
            if (!hasEnforcedConflicts && hasPreferredConflicts) {
                enforceRule = 'conflict_warning';
                errorTitle = 'Requests have been saved, but potential errors need to be approved by a Counselor:';
            }
            if (this.counselor && this.counselorCanOverrideConflicts) {
                enforceRule = 'warning';
            }
            if (hasEnforcedConflicts && !hasPreferredConflicts) {
                errorTitle = 'Some requests could not be met due to the following errors:';
            }
            if (hasEnforcedConflicts || hasPreferredConflicts) {
                const errorList: ErrorList[] = [];
                this.identifiedEnforcedConflicts.forEach(element => {
                    const error: ErrorList = new ErrorList();
                    error.errorMsg = element.ConflictMessage;
                    errorList.push(error);
                });
                this.identifiedPreferredConflicts.forEach(element => {
                    const error2: ErrorList = new ErrorList();
                    error2.errorMsg = element.ConflictMessage;
                    errorList.push(error2);
                });
                this.crWarningDialogRef = this.dialog.open(CRWarningComponent, {
                    disableClose: true,
                    minWidth: '450px',
                    maxWidth: '500px',
                    data: { errorList: errorList, enforceRule: enforceRule, errorTitle: errorTitle },
                });
                this.crWarningDialogRef.afterClosed().subscribe((result2: any) => {
                    if (result2 == 'Save Anyway was clicked') {
                        if (hasEnforcedConflicts) {
                            this.courseRequestMgmtService.OverrideConflicts(this.identifiedEnforcedConflicts).subscribe(x => {
                                console.log('overrideconflicts', x);
                                this.sharedService.showGoodSnackbar();
                                this.getStudentCourseRequestInformation();
                            });
                        }
                    } else {
                        this.getStudentCourseRequestInformation();
                    }
                });
            } else {
                this.sharedService.showGoodSnackbar();
                this.getStudentCourseRequestInformation();
            }
        });
    }

    deleteCourseRequest(scr: StudentCourseRequestDetailDTO, index: number) {
        const course = this.courseOptions.find(o => o.ValueField == scr.DistrictCourse_ID);
        const dialogBox = this.dialog.open(GeneralConfirmationComponent, {
            disableClose: true,
            data: {
                headerLabel: 'Delete Course Request',
                confirmMessage: 'Are you sure you want to delete ' + (course ? course.TextField : 'this course request') + '?'
            }
        });
        dialogBox.afterClosed().pipe(take(1)).subscribe(confirm => {
            if (confirm) {
                const scrReq = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == scr.DistrictRequirement_ID && x.CRType == 'Primary');
                if (scr.CRType == 'Primary' && scrReq.length <= scr.DefaultNumberOfCourseRequests) {
                    scr.StudentCourseRequest_ID = this.tmpStudentCourseRequestId;
                    scr.DistrictCourse_ID = -1;
                    scr.CRType = 'Primary';
                    scr.ParentCR_ID = 0;
                    scr.PreferredTeacher = -1;
                    scr.PreferredTerm = '';
                    scr.PreferredPeriod = '';
                    scr.isHiddenRow = false;
                    this.tmpStudentCourseRequestId = this.tmpStudentCourseRequestId - 1;
                    course.IsAlreadyRequestedCR = false;
                    this.studentCourseRequests.splice(index, 1);
                } else {
                    this.studentCourseRequests.splice(index, 1);
                }
            }
            // if (scr.StudentCourseRequest_ID > 0) {
            //     this.studentCourseRequestService.deleteStudentCourseRequest(scr.StudentCourseRequest_ID).subscribe(result => {
            //         if (result == true) {
            //             if (scr.CRType == 'Primary' && scrReq.length <= scr.DefaultNumberOfCourseRequests) {
            //                 scr.StudentCourseRequest_ID = this.tmpStudentCourseRequestId;
            //                 scr.DistrictCourse_ID = -1;
            //                 scr.CRType = 'Primary';
            //                 scr.ParentCR_ID = 0;
            //                 scr.PreferredTeacher = -1;
            //                 scr.PreferredTerm = '';
            //                 scr.PreferredPeriod = '';
            //                 scr.isHiddenRow = false;
            //                 this.tmpStudentCourseRequestId = this.tmpStudentCourseRequestId - 1;
            //                 course.IsAlreadyRequestedCR = false;
            //                 this.studentCourseRequests.splice(index, 1);
            //             } else {
            //                 this.studentCourseRequests.splice(index, 1);
            //             }
            //         }
            //     });
            // } else if (scr.DistrictCourse_ID > 0) {
            //     if (scr.CRType == 'Primary' && scrReq.length <= scr.DefaultNumberOfCourseRequests) {
            //         scr.DistrictCourse_ID = 0;
            //         scr.PreferredTerm = '';
            //         scr.PreferredPeriod = '';
            //         scr.PreferredTeacher = 0;
            //     } else {
            //         this.studentCourseRequests.splice(index, 1);
            //     }
            // } else {
            //     this.studentCourseRequests.splice(index, 1);
            // }
            this.checkHiddenRow();
            this.setCreditIndicators();
        });
    }
    checkHiddenRow() {
        this.gradeLevelRequirements.forEach(req => {
            const scr = this.studentCourseRequests.filter(x => x.DistrictRequirement_ID == req.DistrictRequirement_ID);
            const tmpSCR: StudentCourseRequestDetailDTO = new StudentCourseRequestDetailDTO();
            tmpSCR.RowNumber = 0;
            tmpSCR.DistrictRequirement_ID = req.DistrictRequirement_ID;
            tmpSCR.SchoolRequirement_ID = req.SchoolRequirement_ID;
            tmpSCR.GradeLevel_ID = req.GradeLevel_ID;
            tmpSCR.RequirementName = req.RequirementName;
            tmpSCR.RequirementInstructions = req.RequirementInstructions;
            tmpSCR.RequirementType = req.RequirementType;
            tmpSCR.ReqMinCredits = req.ReqMinCredits;
            tmpSCR.ReqMaxCredits = req.ReqMaxCredits;
            tmpSCR.ReqMinCourses = req.ReqMinCourses;
            tmpSCR.ReqMaxCourses = req.ReqMaxCourses;
            tmpSCR.DefaultNumberOfCourseRequests = req.DefaultNumberOfCourseRequests;
            tmpSCR.AllowGlobalAlternates = req.AllowGlobalAlternates;
            tmpSCR.AltMinCredits = req.AltMinCredits;
            tmpSCR.AltMaxCredits = req.AltMaxCredits;
            tmpSCR.AltMinCourses = req.AltMinCourses;
            tmpSCR.AltMaxCourses = req.AltMaxCourses;
            tmpSCR.AllowIndividualAlternates = req.AllowIndividualAlternates;
            tmpSCR.NumberOfIndividualAlternates = req.NumberOfIndividualAlternates;
            tmpSCR.RequestedCredits = req.RequestedCredits;
            tmpSCR.StudentCourseRequest_ID = this.tmpStudentCourseRequestId;
            tmpSCR.DistrictCourse_ID = -1;
            tmpSCR.CRType = '';
            tmpSCR.ParentCR_ID = 0;
            tmpSCR.PreferredTeacher = 0;
            tmpSCR.PreferredTerm = '';
            tmpSCR.PreferredPeriod = '';
            tmpSCR.Conflicts = 0;
            tmpSCR.isHiddenRow = true;
            tmpSCR.isHover = false;
            tmpSCR.HighlightMinCredit = false;
            tmpSCR.HighlightMaxCredit = false;
            tmpSCR.imageUrl = '';
            this.tmpStudentCourseRequestId = this.tmpStudentCourseRequestId - 1;
            if (scr.length == 0) {
                this.studentCourseRequests.push(tmpSCR);
                this.studentCourseRequests.push(tmpSCR);
            }
            if (scr.length == 1) {
                this.studentCourseRequests.push(tmpSCR);
            }
        });
        this.reinitializeRowNumber();
    }
    openConflictsInformation(crRow: StudentCourseRequestDTO) {
        alert('Not yet implemented');
    }

    openCourseDescription(crReq: StudentCourseRequestDetailDTO, index: number) {
        // PRE: the user clicks on a course description link under a course
        // POST: shows a modal for the course's description

        const cd: CourseDescription = this.courseDescriptions[crReq.DistrictCourse_ID];
        this.dialog.open(CourseDescriptionDialogComponent, {
            data: {
                course: cd.CourseName,
                courseSection: cd.SubjectIdentifier,
                teacherName: '',
                schoolName: this.studentEnrollment.SchoolName,
                curriculum: cd.CourseCurriculum,
                description: cd.CourseDescription
            },
            disableClose: true
        });
    }

    toolsMenuItemClick(menuItem: MenuItem) {
        // PRE: a menu item on the tools menu is clicked (only available to counselors)
        // POST: navigates to the proper screen
        switch (menuItem.itemName) {
            case 'Schedule Student List':
                this.router.navigateByUrl('counselor360/scheduling/scheduleStudentList');
                break;
            case 'Student Summary':
                this.courseRequestMgmtService.schoolCRM_selectedTab = 'Student Summary';
                this.router.navigateByUrl('counselor360/scheduling/schoolCourseRequestSetup?filterToStudents=Y');
                break;
        }
    }

    redirect(url: string) {
        this.router.navigateByUrl('/counselor360/scheduling/schoolCourseRequestSetup');
    }

    compareObjects(o1: number, o2: number): boolean {
        if (o2 == null) {
            o2 = -1;
        }
        return (o1 == o2);
    }

    openFilter() { }
    resizeGrid() {
        setTimeout(() => {
            this.gridHeight = window.innerHeight - 67 - 30 - this.studentHeaderHeight - this.footerHeight;
        }, 0);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        setTimeout(() => {
            this.resizeGrid();
        }, 0);
    }

    setDirtyFlag() {
        this.formIsDirty = false;
        if (!System.isEqual(this.studentCourseRequests, this.initialStudentCourseRequests)) {
            this.formIsDirty = true;
        }
    }

    checkErrors(nextState?: RouterStateSnapshot): number {
        // PRE: the user tries to navigate away
        // POST: checks the errors.
        //      If 4, shows the warning dialog. If the result is true, it will wait for the save before it continues.
        //      If 3, shows the warning, but doesn't perform route on the save (lets the component do it)
        //      If 2, continues without save.
        //      If 1, continues with save.
        //      If 0, shows warning.
        //      If -1, stops.
        this.errors = [];
        this.setDirtyFlag();
        if (this.formIsDirty) {
            return 3;
        } else {
            return 2;
        }
    }

    continuedWithoutSave(): any {
    }
}
